import React, { Component } from 'react';

import './EcranMenu.css';

//----------------------------------------------------------------------------


class EcranMenu extends Component {


    constructor(props) {

        super(props);
          
        this.state =
        {
            currentId : false   // NOT USED 
        }

        // construit un tableau des IDs, pour simplifier la recherche ensuite
        this.liste_ids = [];
        let i = 0;

        const chapitres = window.g_DATA_CONFIG;        
        let contenu = chapitres.map((chapitre) => {
            for(let entry in chapitre.entries)
            {
                const e = chapitre.entries[entry];
                //this.liste_ids[e.id] = { i: i++, t: e.menu_titre };
                this.liste_ids[i++] = { id: e.id, t: e.menu_titre };
            } 
        });
        //console.log(this.liste_ids);

    }

    componentDidMount() 
    {


    }

    componentWillUnmount()
    {

    }
/*
    shouldComponentUpdate(nextProps, nextState)
    {      
        if(nextProps.currentId != this.props.currentId)
            return true;
        else
            return false;
    }        
*/
    render() {

        //console.log('## render')

        const chapitres = window.g_DATA_CONFIG;
        const config = window.g_CONFIG_UI;

        //let chapitre = 1;

        if(!chapitres)
        { 
            this.props.logFn("EcranMenu:Error no g_DATA_CONFIG defined !")
            return;
        }
        if(!config)
        { 
            this.props.logFn("EcranMenu:Error no g_CONFIG defined !")
            return;
        }        

        //console.log("OK1");

        let clv = 'menuBlockAnimation';

        let count_id = 0;

        let contenu = chapitres.map((chapitre) => {

            /* les contenus des chapitres */

            var contenu_animations = [];

            for(let entry in chapitre.entries)
            {
                // balaye toutes les entrées                                
                const e = chapitre.entries[entry];

               
                // cherche le titre précédent et le suivant, pour savoir si l'item e.id du menu est à afficher (courant) et les suivant à atténuer
                let pos_ci = 0;
                let prev_ti = 0;
                // cherche le précédent titre jusqu'à l'item courant
                for(let i=0;i<this.liste_ids.length;i++)
                {
                    if(this.liste_ids[i].t) prev_ti = i;
                    if(this.liste_ids[i].id == this.props.currentId){ pos_ci = i; break; }
                }
                // cherche le titre suivant
                let next_ti = 0;
                for(let i=pos_ci + 1 /* next */;i<this.liste_ids.length;i++)
                    if(this.liste_ids[i].t){  next_ti = i; break; }
                if( next_ti == 0)    next_ti = this.liste_ids.length; // cas de la fin

                if( count_id >= prev_ti ) clv = 'menuBlockAnimation menuBlockCourant';
                if( count_id >= next_ti )  clv = 'menuBlockAnimation menuBlockNonVu';           // pas de else, normal : écrase menuBlockCourant

                //console.log(e.id, this.props.currentId, " - ", prev_ti, pos_ci, next_ti, count_id, clv);

                if( e.menu_titre)
                {
                    //console.log('set title');
               
                    const vignette = "url(./UI/menu_" + e.id + ".png)";
                    
                    const style_vig = { backgroundImage: vignette };
                    const vk = "vignette_" + e.id;

                    contenu_animations.push(
                        <div className={ clv } key={ vk } onClick={ () => this._onClickVignette(e.id) }>
                            <div className='menuBlockVignette' style={ style_vig } ></div>
                            <div className='menuBlockTitreAnimation'> 
                            {e.menu_titre.map((item, key) => {
                                if(item != "")
                                    return <span key={key}>{item}<br/></span> /* pour ajouter des <br/> */
                                return null;
                            })}
                            </div>
                        </div>
                    )
                }
                count_id ++;
            }

            /* les block de chapitres */

            const style_bk = { backgroundColor: config.chapitres_colors[chapitre.num - 1] };
            const style_ct = { color: config.chapitres_textes_colors[chapitre.num - 1] };
            const ck = "chapitre" + chapitre.num;
            //const ct = "titre" + chapitre.num;

            return(
                <div className='menuBlockChapitre' key={ck} style={ style_bk } >
                    <div className='menuTitreChapitre' style={ style_ct }>
                    { chapitre.titre.map((item, key) => {
                                return <span key={key}>{item}<br/></span> /* pour ajouter des <br/> */
                    })}
                    </div>
                    <div className='menuContainerVignettes'>
                    { contenu_animations }
                    </div>
                </div>
            );

        });

        /* interface boutons bas */

        contenu.push(
            <div className='menuBlockBoutons' key='menuBlockBoutons'>                
                
                <div className='menuBlockBouton' onClick={ this._onClickDebut }>
                    <div className='menuBlockVignetteDebut'></div>
                    <div className='menuBlockTitreAnimation'> Revenir au début </div>
                </div>
                <div className='menuBlockBouton' onClick={ this._onClickCredits }>
                    <div className='menuBlockVignetteCredits'></div>
                    <div className='menuBlockTitreAnimation'> Crédits </div>
                </div>
            </div>
        );


        const { onClickMenuTriangle } = this.props;

        return <div className='EcranMenu'>
                <div className="icon_menu" onClick={onClickMenuTriangle}>
                    <div className="triangle_bkg_menu"></div>
                    <div className="icon_triangle_menu_open"></div>
                </div>        
                { contenu }
            </div>;    
  }



  _onClickVignette = ( v ) =>
  {
    this.props.logFn("EcranMenu:_onClickVignette(): "+v);

    const { gotoAppState } = this.props;
    if(gotoAppState)   gotoAppState(v);

  }

  _onClickDebut = ( ) =>
  {
    this.props.logFn("EcranMenu:_onClickDebut()");

    const { gotoAppState } = this.props;
    if(gotoAppState)   gotoAppState('A01');   // 

  }

  _onClickCredits = ( ) =>
  {
    this.props.logFn("EcranMenu:_onClickCredits()");

    const { gotoAppState } = this.props;
    if(gotoAppState)   gotoAppState('A28');   // 
  }
}

//----------------------------------------------------------------------------

export default EcranMenu;



// WEBPACK FOOTER //
// ./src/EcranMenu.js